<template>
  <div class="Dashbord">
    <!-- <template v-if="show_history">
      <HistoryButton></HistoryButton>
    </template> -->

    <ActionsNav></ActionsNav>
    <div class="Actions__Content">
      <v-container fluid>
        <Breadcrumbs />
        <!-- /.Breadcrumbs -->

        <section class="TankRoom">
          <h2>
            {{ this.items.name }}
          </h2>

          <div class="FlexHolder">
            <!--    :data-tank-phase-vine-id="this.items.wine.wineType.id" -->
            <div
              :class="'Tank TankSingle '"
              :data-tank-id="this.items.id"
              :data-tank-phase-vine-id="0"
              :data-tank-quantity="this.items.quantity"
              :data-tank-phase="0"
              :data-wine-type="0"
              :data-tank-name="this.items.name"
              :data-tank-phase-mark="0"
              :data-unit-of-measure="0"
              :data-unit-of-measure-id="0"
              :data-tank-type-lable="this.items.tankType.enumLable"
            >
              <div class="Tank__Bar">
                <span class="counter">0%</span>
                <div class="bar">
                  <span class="bar_Fill" :style="'height: 0%'"></span>
                  <span class="bar_Bkg"></span>
                </div>
              </div>
              <!-- /.Tank__Bar -->

              <div class="Tank__Content">
                <p class="vineType">Prazan tank</p>

                <div class="Tank__Img">
                  <img
                    :src="'../assets/iconsTanks/' + this.tank_type + '.svg'"
                    alt="Tank Image"
                  />
                </div>
                <!-- /.Tank__Img -->

                <div class="Tank__Info">
                  <h4 v-if="this.items.tankType.name==='barik'">{{ this.items.inventoryNumber }}</h4>
                  <!-- <h4 v-else>{{ this.items.name }}</h4> -->
                  <p class="amauntAvailable">0{{ this.items.unitOfMeasure.mark }} / {{ this.items.capacity }}{{ this.items.unitOfMeasure.mark }}</p>
                </div>
                <!-- /.Tank__Info -->
              </div>
              <!-- /.Tank__Content -->
            </div>
            <!-- /.Tank -->

            <div class="TankDetails">
              <div class="TankDetails__Item" v-if="this.items.tankType.name === 'barik'">
                <span class="label">Datum nabavke:</span>
                <span class="value"
                  >{{ this.items.bayingDate }}</span
                >
              </div>
              <div class="TankDetails__Item">
                <span class="label">Kapacitet:</span>
                <span class="value"
                  >{{ this.items.capacity }}
                  {{ this.items.unitOfMeasure.name }}</span
                >
              </div>
              <!-- /.TankDetails__Item -->

              <div class="TankDetails__Item">
                <span class="label">Popunjenost:</span>
                <span class="value">0%</span>
              </div>
              <!-- /.TankDetails__Item -->

              <div class="TankDetails__Item">
                <span class="label">Faza:</span>
                <span class="value"></span>
              </div>
              <!-- /.TankDetails__Item -->

              <div class="TankDetails__Item">
                <span class="label">Vino:</span>
                <span class="value"></span>
              </div>
              <!-- /.TankDetails__Item -->

              <div class="TankDetails__Item" v-if="this.items.piece !== null && this.items.piece !== 0">
                <span class="label">Broj barika:</span>
                <span class="value">{{ this.items.piece }} komada</span>

                <span style="padding-left: 15px">
                  <button @click="otvoriModal_izabrani_tankovi">
                    <img
                      :src="`../assets/Ikone/icons8-edit-24_bela.png`"
                      alt="icon"
                      title="Prikaži barike"
                    />
                  </button>
                </span>
              </div>

              <div class="TankDetails__Item" v-if="this.items.tankType.name === 'barik'">
                <span
                  class="label" style="width:150px!important;"
                  ><a
                    v-on:click="otvoriDialog()"
                    >Istorija korišćenja</a
                  ></span
                >
              </div>
            </div>
            <!-- /.TankDetails -->

            <div class="TankDetails">
              <div class="TankDetails__Item" v-if="show_history">
                <span class="label">Vraćanje istorije:</span>
                <span class="value">
                  <v-icon
                      slot="activator"
                      class="ml-2"
                      @click="submit_history"
                      title="Vrati prethodno stanje tanka"
                      >fa-search</v-icon
                    >
                </span>
              </div>
              <!-- <div class="TankDetails__Item">
                <span class="label">Vrsta:</span>
                <span class="value">{{ this.items.tankType.description }}</span>
              </div> -->

              <!-- <div class="TankDetails__Item">
                <span class="label">Proizvodjač:</span>
                <span class="value">{{ this.items.producer }}</span>
              </div>
              <div class="TankDetails__Item">
                <span class="label">Kupljen:</span>
                <span class="value">{{ this.items.bayingDate }}</span>
              </div>
              <div class="TankDetails__Item">
                <span class="label">Cena:</span>
                <span class="value">{{ this.items.price }} {{ this.items.currency.name }}</span>
              </div>
              <div class="TankDetails__Item">
                <span class="label">Opis:</span>
                <span class="value">{{ this.items.description }}</span>
              </div> -->
            </div>
            <!-- /.TankDetails -->
          </div>
          <!-- /.FlexHolder -->
        </section>
        <!-- /.TankRoom -->

        <v-dialog
          v-model="dialogNote_izabrani_tankovi"
          scrollable
          content-class="ModalInModal"
        >
          <v-container>
            <div class="DataTable">
              <v-form ref="form_modal">
                <v-layout>
                  <v-flex xs11 pa-2 style="font-size: 20px !important">
                    Spisak barika u šarži - {{ this.items.name }}
                  </v-flex>
                  <v-flex xs1 pa-2>
                    <a
                      class="closeModalInModalBtn"
                      @click.prevent="closeModalInModal_izabrani_tankovi"
                      style=""
                    >
                      <v-icon>close</v-icon>
                    </a>
                  </v-flex>
                </v-layout>

                <v-layout column>
                  <v-flex style="overflow: auto">
                    <v-data-table
                      :headers="headers_modal_izabrani_tankovi"
                      :items="items_modal_izabrani_tankovi"
                      hide-actions
                      class="elevation-1"
                      show-select
                      dense
                      select-all
                      :pagination.sync="pagination"
                    >
                      <template slot="headers" slot-scope="props_modal">
                        <tr>
                          <th
                            style="text-align: center; padding: 5px"
                            v-for="header in props_modal.headers"
                            :key="header.text"
                            :class="[
                              'column sortable',
                              pagination.descending ? 'desc' : 'asc',
                              header.value === pagination.sortBy
                                ? 'active'
                                : '',
                            ]"
                            @click="changeSort(header.value)"
                          >
                            <v-icon>arrow_upward</v-icon>
                            {{ header.text }}
                          </th>
                        </tr>
                      </template>
                      <template slot="items" slot-scope="props_modal">
                        <tr
                          :active="props_modal.selected"
                          @click="props_modal.selected = !props_modal.selected"
                        >
                          <td style="display: none">
                            {{ props_modal.item.tank.id }}
                          </td>
                          <td style="text-align: center; padding: 5px;background: #f3f7f4">
                            {{ props_modal.item.tank.name }}
                          </td>
                          <td style="text-align:center; padding-left:5px; padding-right: 5px;">{{ props_modal.item.tank.inventoryNumber }}</td>
                          <td style="text-align: center; padding: 0px">
                            {{ formatDate1(props_modal.item.tank.bayingDate) }}
                          </td>
                          <td style="text-align: center; padding: 5px;">
                            {{
                              props_modal.item.tank.capacity +
                              " " +
                              props_modal.item.tank.unitOfMeasure.mark
                            }}
                          </td>

                          <td
                            style="text-align: center; padding: 5px;"
                            v-if="props_modal.item.tank.materialType !== null"
                          >
                            {{ props_modal.item.tank.materialType }}
                          </td>
                          <td v-else>{{ "" }}</td>
                          <td
                            style="text-align: center; padding: 5px;"
                            v-if="props_modal.item.tank.producer !== null"
                          >
                            {{ props_modal.item.tank.producer }}
                          </td>
                          <td v-else>{{ "" }}</td>
                        </tr>
                      </template>
                      <template slot="no-data">
                        <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
                        <v-alert
                          slot="no-results"
                          :value="true"
                          color="primary"
                          icon="info"
                          >Nema podataka.</v-alert
                        >
                      </template>
                    </v-data-table>
                  </v-flex>
                  <v-flex xs11 pa-2 style="font-size: 12px !important">
                    Osenčeni barici su ispražnjeni
                  </v-flex>
                </v-layout>
              </v-form>
            </div>
          </v-container>
        </v-dialog>
      </v-container>
    </div>

    <v-dialog
      v-model="dialogNoteStanjeBarika"
      scrollable
      content-class="ModalInModal"
    >
      <v-container style="padding: 10px">
        <div class="DataTable">
          <v-form ref="form_modal" lazy-validation>
            <v-layout>
              <v-flex xs11 pa-2 style="font-size: 20px !important">
                {{ this.naslovKoriscenjeBarika }}
              </v-flex>
              <v-flex xs1 pa-2>
                <a
                  class="closeModalInModalBtn"
                  @click.prevent="closeModalInModalStanjeBarika"
                >
                  <v-icon>close</v-icon>
                </a>
              </v-flex>
            </v-layout>

            <v-layout column>
              <v-flex style="overflow: auto">
                <v-data-table
                  :headers="headers_modal_stanje_barika"
                  :items="items_modal_stanje_barika"
                  hide-actions
                  class="elevation-1"
                  :pagination.sync="pagination"
                >
                  <template slot="headers" slot-scope="props_modal">
                    <tr>
                      <th
                        v-for="header in props_modal.headers"
                        :key="header.text"
                        :class="[
                          'column sortable',
                          pagination.descending ? 'desc' : 'asc',
                          header.value === pagination.sortBy ? 'active' : '',
                        ]"
                        @click="changeSort(header.value)"
                      >
                        <v-icon>arrow_upward</v-icon>
                        {{ header.text }}
                      </th>
                    </tr>
                  </template>
                  <template slot="items" slot-scope="props_modal">
                    <tr>
                      <td style="text-align: center; padding: 5px">
                        {{ props_modal.item.wine }}
                      </td>
                      <td style="text-align: center; padding: 5px">
                        {{ props_modal.item.phase }}
                      </td>

                      <td style="text-align: center; padding: 5px">
                        {{ props_modal.item.batchName }}
                      </td>
                      <td style="text-align: center; padding: 0px">
                        {{ formatDateTime(props_modal.item.from) }}
                      </td>
                      <td style="text-align: center; padding: 0px">
                        {{ formatDateTime(props_modal.item.to) }}
                      </td>

                      <td style="text-align: center; padding: 5px" v-if="props_modal.item.years > 0">
                        {{
                          props_modal.item.years +
                          " g " +
                          props_modal.item.months +
                          " m"
                        }}
                      </td>
                      <td style="text-align: center; padding: 5px" v-else>
                        {{
                          "   " +
                          props_modal.item.months +
                          " m"
                        }}
                      </td>
                    </tr>
                  </template>
                  <template slot="no-data">
                    <v-alert
                      slot="no-results"
                      :value="true"
                      color="primary"
                      icon="info"
                      >Nema podataka.</v-alert
                    >
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-form>
        </div>
      </v-container>
    </v-dialog>
    <!-- /.Actions__Content -->
    <TokenComponent ref="frmtoken" />
  </div>
</template>

<script>
import TokenComponent from "@/components/Token";
import { serverBus } from "../main";
import { readJSON } from "../helpers/Functions";

import Breadcrumbs from "../components/layoutComponents/Breadcrumbs";
import ActionsNav from "./parts/ActionsNav";
import GrapeInput from "./GrapeInput";
import HistoryButton from "./parts/HistoryButton";

export default {
  name: "emptyTank",
  components: {
    Breadcrumbs,
    GrapeInput,
    ActionsNav,
    HistoryButton,
    TokenComponent,
  },
  data() {
    return {
      idTank: 0,
      actionId: 0,
      items: {
        name: "",
        tankType: {
          name: "",
        },
        description: "",
        unitOfMeasure: {
          name: "",
        },
        currency: {
          name: "",
        },
        room: {
          name: "",
        },
      },
      show_history: false,
      tank_type: "tank-inox",
      idTankFazaVino: 0,
      imaIstoriju: 0,
      items_modal_izabrani_tankovi: [],
      headers_modal_izabrani_tankovi: [
        { text: "Naziv", value: "tank.name" },
        { text: "Inventarski broj", value: "tank.inventoryNumber" },
        { text: "Datum nabavke", value: "tank.bayingDate" },
        { text: "Kapacitet", value: "tank.capacity" },
        // { text: "JM", value: "width" },
        { text: "Materijal", value: "tank.materialType" },
        { text: "Proizvođač", value: "tank.producer" },
      ],
      dialogNote_izabrani_tankovi: false,
      naziv: "",
      pagination: {
        sortBy: "id",
        rowsPerPage: 10000000,
      },
      items_modal_stanje_barika: [],
      dialogNoteStanjeBarika: false,
      naslovKoriscenjeBarika:"Pregled korišćenja barika",
    headers_modal_stanje_barika: [
      { text: "Vino", value: "wine" },
      { text: "Faza", value: "phase" },
      { text: "Šarža", value: "batchName" },
      { text: "Od", value: "from" },
      { text: "Do", value: "to" },
      { text: "Odležavalo", value: "wineType" },
    ]
    };
  },
  methods: {
    getAllSifarnikStanjeBarika(tankId) {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/tank/barique_history/" +
            tankId,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          console.log(response.data);

          this.items_modal_stanje_barika = response.data;
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/tank/barique_history/" +
                        tankId,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.items_modal_stanje_barika = response.data;
                    })
                    .catch((e) => {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    formatDateTime(date) {
      if (typeof date !== "undefined" && date !== null) {
        let lokDate = date.split("T")[0];
        let lokTime = date.split("T")[1];

        let month = lokDate.split("-")[1];
        let day = lokDate.split("-")[2];
        const year = lokDate.split("-")[0];

        let HH = lokTime.split(":")[0];
        let mm = lokTime.split(":")[1];

        return [day, month, year].join(".") + " " + [HH, mm].join(":");
      } else return "";
    },
    closeModalInModalStanjeBarika() {
      this.items_modal_stanje_barika = [];

      this.dialogNoteStanjeBarika = false;
    },
    otvoriDialog() {
      //scrollToTop(300);
      

      let item = this.items;
      let id;
      let name;

      if (typeof item.tank !== "undefined") {
        id = item.tank.id;
        name = item.tank.name;
      } else {
        id = item.id;
        name = item.name;
      }

      this.items_modal_stanje_barika = [];

      this.dialogNoteStanjeBarika = true;
      this.getAllSifarnikStanjeBarika(id);

      this.naslovKoriscenjeBarika = "Pregled korišćenja barika - " + name;
    },
    formatDate1(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    changeSort(column) {
      if (column !== "funkcije")
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending;
        } else {
          this.pagination.sortBy = column;
          this.pagination.descending = false;
        }
    },
    closeModalInModal_izabrani_tankovi() {
      this.selected_izabrani_tankovi = [];
      this.items_modal_izabrani_tankovi = [];

      this.dialogNote_izabrani_tankovi = false;
    },
    otvoriModal_izabrani_tankovi() {
      this.dialogNote_izabrani_tankovi = true;
      this.getAllSifarnik2();
    },
    routerLinkToDetails(lokIDTank) {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/tank_phase_wine/tank/" +
            lokIDTank,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // // console.log(response.data);
          let lokID = response.data;

          this.$router.push({
            name: "single_tank",
            params: { id: lokID, idTank: lokIDTank },
          });
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/tank_phase_wine/tank/" +
                        lokIDTank,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);
                      let lokID = response.data;

                      this.$router.push({
                        name: "single_tank",
                        params: { id: lokID, idTank: lokIDTank },
                      });
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllSifarnik2() {
      // console.log(this.idTank);

      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/tank/tanks_in_batch/" +
            this.idTank,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // this.selected_izabrani_tankovi = response.data;
          this.items_modal_izabrani_tankovi = response.data;

          // console.log(response.data);
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/tank/tanks_in_batch/" +
                        this.idTank,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // this.selected_izabrani_tankovi = response.data;
                      this.items_modal_izabrani_tankovi = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    daLiJeTankPrazan(lokIDTank) {
      

      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/tank/" +
            lokIDTank +
            "/is_tank_empty",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          console.log(response.data);

          if (response.data === false) this.routerLinkToDetails(lokIDTank);
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/tank/" +
                        lokIDTank +
                        "/is_tank_empty",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      if (response.data === false)
                        this.routerLinkToDetails(lokIDTank);
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    submit_history(e) {
      e.preventDefault();

      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/tank_phase_wine/tank/" +
            this.idTank +
            "/empty_tank_history",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.$router.push({
            name: "single_tank",
            params: {
              id: this.idTankFazaVino,
              idTank: this.idTank,
              active: true,
            },
          });
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/tank_phase_wine/tank/" +
                        this.idTank +
                        "/empty_tank_history",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.$router.push({
                        name: "single_tank",
                        params: {
                          id: this.idTankFazaVino,
                          idTank: this.idTank,
                          active: true,
                        },
                      });
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllSifarnik() {
      this.$http
        .get(
          this.globalServiceLocation + this.globalPort + "/tank/" + this.idTank,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // console.log(response.data);

          this.items = response.data;

          this.tank_type = response.data.tankType.name;

          this.getShowHistory();
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/tank/" +
                        this.idTank,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.items = response.data;

                      this.tank_type = response.data.tankType.name;

                      this.getShowHistory();
                    })
                    .catch((e) => {
                      // // console.log(e.message);
                      alert(1);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getShowHistory() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/tank_phase_wine/tank/" +
            this.idTank +
            "/empty_tank_history",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // // console.log(response.data);

          let nizVrednosti;

          if (response.data !== "") {
            this.idTankFazaVino = response.data;
            this.show_history = true;
          } else {
            this.idTankFazaVino = 0;
            this.show_history = false;
          }

          nizVrednosti = [
            false,
            true,
            true,
            false,
            true,
            true,
            true,
            true,
            true,
            true,
            true,
            false
          ];
          serverBus.$emit("disable_action", nizVrednosti);

          //this.show_history = false;
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/tank_phase_wine/tank/" +
                        this.idTank +
                        "/empty_tank_history",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // alert(111);

                      // // console.log(response.data);

                      let nizVrednosti;

                      if (response.data !== "") {
                        this.idTankFazaVino = response.data;
                        this.show_history = true;
                      } else {
                        this.idTankFazaVino = 0;
                        this.show_history = false;
                      }

                      nizVrednosti = [
                        false,
                        true,
                        true,
                        false,
                        true,
                        true,
                        true,
                        true,
                        true,
                        true,
                        true,
                        false
                      ];
                      serverBus.$emit("disable_action", nizVrednosti);

                      //this.show_history = false;
                    })
                    .catch((e) => {
                      // // console.log(e.message);
                      // alert(1);
                      // alert(this.$lang.general.greskaNaServeru);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
  },
  watch: {
    $route() {
      this.idTank = this.$route.params.id;
      this.getAllSifarnik();
      // this.getShowHistory();
    },
  },
  beforeMount() {
    serverBus.$off("ucitaj_podatke");
    this.idTank = this.$route.params.id;
    this.getAllSifarnik();
    // this.getShowHistory();

    serverBus.$on("ucitaj_podatke", () => {
      this.daLiJeTankPrazan(this.idTank);
    });
  },
};
</script>

<style scoped lang='scss'>
@import "../assets/sass/viewStyles/EmptySingleTank";

.closeModalInModalBtn {
  position: absolute;
  right: 0;
  top: 0;
}

span.label{
  width: 120px !important;
}
</style>
